// @flow
import React from "react";
import Button from "@localytics/loc-components/lib/Button";
import "./stylesheets/KVForm.scss";
import "./stylesheets/FormField.scss";

class KVForm extends React.Component<{
  keys: Array<string>,
  values: Array<string>,
  updateKVKeys: Function,
  updateKVValues: Function,
  addEmptyKeyValue: Function,
  removeKeyValue: Function,
  disabled: boolean
}> {
  addEmptyKeyValue: Function = () => this.props.addEmptyKeyValue();

  updateKVKeys: Function = event => {
    const { target: { value, dataset } } = event;
    this.props.updateKVKeys(value, dataset.index);
  };

  updateKVValues: Function = event => {
    const { target: { value, dataset } } = event;
    this.props.updateKVValues(value, dataset.index);
  };

  removeKeyValue: Function = index => this.props.removeKeyValue(index);

  render() {
    const { keys, values, disabled = false } = this.props;
    return (
      <div className="FormField">
        <span className="FormField__Label">KEY/VALUE PAIRS</span>
        {keys.map((key, index) => (
          /* eslint-disable react/no-array-index-key */
          <div className="KVForm" key={index}>
            <input
              className="KVForm__Input"
              type="text"
              placeholder="Key"
              value={key}
              data-index={index}
              onChange={this.updateKVKeys}
              disabled={disabled}
            />
            <span className="KVForm__Separator">=</span>
            <input
              className="KVForm__Input"
              type="text"
              placeholder="Value"
              value={values[index]}
              data-index={index}
              onChange={this.updateKVValues}
              disabled={disabled}
            />
            <Button
              onClick={() => this.removeKeyValue(index)}
              className="KVForm__RemoveButton"
              type="danger"
              size="small"
              tabIndex="-1"
              disabled={disabled}
            >
              remove
            </Button>
          </div>
        ))}
        <Button
          onClick={this.addEmptyKeyValue}
          className="KVForm__AddButton"
          type="new"
          size="small"
          tabIndex="-1"
          disabled={disabled}
        >
          add
        </Button>
      </div>
    );
  }
}

export default KVForm;



// WEBPACK FOOTER //
// ./node_modules/@localytics/push-message-builder/src/components/KVForm.jsx